import React from 'react';
import useAgentConfig from '../../../hooks/useAgentConfig';
import PromptEditor from '../components/PromptEditor';
import ToolToggleList from '../components/ToolToggleList';
import ModelSelector from '../components/ModelSelector';

function ConfigurationTab({ agent }) {
  const { config, setConfig, isLoading } = useAgentConfig(agent.id);

  if (isLoading || !config) {
    return <p className="tab-empty">Loading configuration…</p>;
  }

  const toggleTool = (toolId) => {
    setConfig((previous) => ({
      ...previous,
      tools: previous.tools.map((tool) => (
        tool.id === toolId ? { ...tool, enabled: !tool.enabled } : tool
      ))
    }));
  };

  const selectModel = (modelId) => {
    setConfig((previous) => ({ ...previous, selectedModelId: modelId }));
  };

  return (
    <div className="config-grid">
      <section className="tab-section">
        <PromptEditor
          onChange={(systemPrompt) => setConfig((previous) => ({ ...previous, systemPrompt }))}
          onReset={() => setConfig((previous) => ({ ...previous, systemPrompt: config.systemPrompt }))}
          value={config.systemPrompt}
        />
      </section>
      <aside className="side-stack">
        <section className="tab-section">
          <header className="section-heading">
            <div><h3>Tools</h3><span>Granted capabilities</span></div>
          </header>
          <ToolToggleList onToggle={toggleTool} tools={config.tools} />
        </section>
        <ModelSelector
          models={config.models}
          onSelect={selectModel}
          selectedModelId={config.selectedModelId}
        />
      </aside>
    </div>
  );
}

export default ConfigurationTab;
